<template>
    <div class="p-3">
        <b-card
            title="Konfigurasi Website"
        >
            <b-card-text>
                <form class="mt-5">
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Nama RS</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form.name"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Logo RS</label>
                        <div class="col-lg-6">
                            <b-form-file @change="handleFileInput"></b-form-file>
                        </div>
                    </div>
                    <div v-if="form.logo" class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Logo Preview</label>
                        <div class="col-lg-6">
                            <b-img :src="'/assets/img/logo/logo-rs/' + logo_preview" style="max-width: 25%; height: auto;"></b-img>
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Alamat RS</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form.address"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Nomor Telp RS</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form.phone"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Judul Halaman</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form.app_title"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Deskripsi Halaman</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form.app_desc"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row pb-4" style="display: none;">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Metode Antrean</label>
                        <div class="col-lg-6">
                            <b-form-radio-group
                                v-model="form.metode_antrean"
                                :options="option_metode_antrean"
                                value-field="value"
                                text-field="text"
                            ></b-form-radio-group>
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <div class="col-lg-3 text-lg-end pt-2"></div>
                        <div class="col-lg-6">
                            <b-button class="btn-sm" variant="primary" @click="saveRsData">Simpan</b-button>
                            <b-button class="btn-sm" variant="danger" @click="cancelAdd">Batal</b-button>
                        </div>
                    </div>
                </form>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: null,
            access_token: null,
            logo_preview: null,
            form: {
                id: 0,
                name: '',
                logo: '',
                address: '',
                phone: '',
                app_title: '',
                app_desc: '',
                metode_antrean: 2,
            },
            option_metode_antrean: [
                {
                    value: 1,
                    text: 'Bebas'
                },
                {
                    value: 2,
                    text: 'Menurut Loket'
                },
                {
                    value: 3,
                    text: 'Menurut Kategori'
                },
            ]
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getRsData()
        },
        getRsData() {
            this.$isLoading(true)
            let uri = '/api/konf_rs_data?id=1'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                if (response.data.status == 'success') {
                    let rs_data = response.data.rs_data
                    if (rs_data) {
                        this.logo_preview = rs_data.rs_logo
                        this.form = {
                            id: rs_data.id,
                            name: rs_data.rs_name,
                            logo: rs_data.rs_logo,
                            address: rs_data.rs_address,
                            phone: rs_data.rs_phone,
                            app_title: rs_data.app_title,
                            app_desc: rs_data.app_desc,
                            metode_antrean: rs_data.metode_antrean,
                        }
                    } else {
                        this.form = {
                            id: 0,
                            name: '',
                            logo: '',
                            address: '',
                            phone: '',
                            app_title: '',
                            app_desc: '',
                            metode_antrean: '',
                        }
                    }
                }

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        saveRsData() {
            this.$isLoading(true)
            let uri = '/api/konf_rs_data'
            let formData = new FormData()
            formData.append('name', this.form.name)
            formData.append('logo', this.form.logo)
            formData.append('address', this.form.address)
            formData.append('phone', this.form.phone)
            formData.append('app_title', this.form.app_title)
            formData.append('app_desc', this.form.app_desc)
            formData.append('metode_antrean', this.form.metode_antrean)

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, formData, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'Data RS Berhasil Diupdate!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
                this.$isLoading(false)
                this.$router.go(0)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        handleFileInput() {
            this.form.logo = event.target.files[0]
        },
        cancelAdd() {
            this.$router.push('portal')
        }
    }
    
}
</script>